// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';
// import './App.css';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.jsx';
import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');

// Create a root layout
const root = createRoot(container);

// Render the App component inside StrictMode for development checks
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);